<!-- My Compensation History -->
<div class="TRS__sub-section">
  <header class="TRS__sub-section__header">
    <h3 class="tertiary-heading">My Compensation History</h3>
    <p class="TRS__sub-section__header__description">
      Your historical cash compensation is below. Amounts may change annually based on
      individual, business area and company performance. Because when you succeed, the company
      succeeds.
    </p>
  </header>

  <!-- Compensation History Chart -->
  <!--
  NOTE 1: Setting `max-width` to an extra-wide amount so that
  it's guaranteed that the chart takes up 100% of the space
  NOTE 2: `width` and `height` both set to `100%`, and `aspect-ratio` set
  is needed for the chart to be completely responsive (it's set in component.ts).
  If not, it will shrink on browser width shrink, but when increasing the browser
  width back, the chart will stay as its shrunk size (i.e. does not grow). The
  `aspect-ratio` also needs to be set in the `options.aspectRatio` Chart.js config
  -->
  <div class="chart-wrapper"
    style="width: 100%; height: 100%; max-width: 5000px; margin: auto; margin-bottom: 32px;">
    <canvas id="stackedBarChart"></canvas>
    <p class="chart-wrapper__footnote">*Includes all bonuses and
    allowances</p>
    @if (hideFigures$ | async; as hide) {
      @if (hide) {
        <div class="chart-mask"></div>
      }
    }
  </div>
</div>
